// import { getConfig } from '@/utils/tools'
// let conf = getConfig()
export default {
  name: 'login',
  path: '/login',
  component: () => import('@/view/login/index.vue')
  // redirect: () => {
    // window.location.href = conf.dm_host + '/loanv5/user/login'
  // }
}